import { useEffect, useRef } from 'react';
import { Parameters } from 'constants/queryParameters';
import { useQuerySearchParams } from './useQuerySearchParams';

/**
 * @example
 * const { page, size, setPage, setSize } = useQueryPage();
 */
export const useQueryPage = () => {
  let [page, setPage] = useQuerySearchParams<number>(Parameters.page);
  let [size, setSize] = useQuerySearchParams<number>(Parameters.size);

  const prevSize = useRef(size);

  useEffect(() => {
    if (prevSize.current !== size) {
      setPage(1);
      prevSize.current = size;
    }
  }, [size]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page, size]);

  return { size: Number(size ?? 10), page: Number(page ?? 1), setSize, setPage };
};
